import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const inventoryProductsInStockWidget: DashboardWidgetConfiguration = {
  widgetId: 'inventory.products-in-stock',
  name: 'Products in stock',
  description: 'Largest 50 products by current on-hand quantity in their inventory base unit; tile area compares quantities, not value.',
  apps: ['inventory'],
  template: 'report',
  query: {kind: 'single', query: {
    version: 1, source: 'inventory.stock', ...period(1),
    select: [
      {type: 'field', field: 'product_name', as: 'product_name'},
      {type: 'field', field: 'uom_name', as: 'unit'},
      {type: 'aggregate', function: 'sum', field: 'on_hand_quantity', as: 'quantity'},
    ],
    group_by: [{field: 'product_id'}, {field: 'product_name'}, {field: 'uom_name'}],
    having: {type: 'condition', expression: {type: 'aggregate', function: 'sum', field: 'on_hand_quantity'}, operator: 'gt', value: 0},
    order_by: [{ref: 'quantity', direction: 'desc'}, {ref: 'product_name', direction: 'asc'}], limit: 50,
  }},
  inputs: {title: 'Products in stock', subtitle: 'Top 50 · current on-hand quantity · base units',
    output: 'category_series', visualization: 'treemap', icon: 'orders', showTimeControls: false,
    colors: ['#206bc4', '#087f5b', '#9c4a00', '#b02525', '#862e9c'],
    emptyText: 'No products currently in stock.'},
  dummyData: {value: '50 products', series: [50, 30, 20, 12, 8]},
  limits: {minWidth: 6, maxWidth: 12, minHeight: 4, maxHeight: 8, defaultWidth: 12, defaultHeight: 5},
};
